// mds-dojo — dijit/form/CurrencyTextBox — FAITHFUL port of references/dijit/form/CurrencyTextBox.js.
// Codemod pipeline; declare from the faithful runtime. Adaptations:
//  - `dojo/currency` does not exist in mds; ported faithfully to the local ./_currency helper
//    (kept inside dijit/form/ since editing outside is out of scope). See the LOUD flag in
//    ./_currency for the (locale + format-symbol) behavioral notes.
// A validating currency textbox (NumberTextBox with currency symbol / places handling).
import currency from './_currency'; // currency._mixInDefaults currency.format currency.parse currency.regexp
import declare from '../../dojo/_base/declare-runtime'; // declare
import lang from '../../dojo/_base/lang'; // lang.hitch
import NumberTextBox from './NumberTextBox';

var CurrencyTextBox: any = declare("dijit.form.CurrencyTextBox", NumberTextBox, {
	// summary:
	//		A validating currency textbox

	// currency: [const] String
	//		the [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code, a three letter sequence like "USD"
	currency: "",

	baseClass: "dijitTextBox dijitCurrencyTextBox",

	// Override NumberTextBox._formatter to deal with currencies, ex: converts "123.45" to "$123.45"
	_formatter: currency.format,

	_parser: currency.parse,

	_regExpGenerator: currency.regexp,

	parse: function (/*String*/ value: any, /*Object*/ constraints: any) {
		// summary:
		//		Parses string value as a Currency, according to the constraints object
		// tags:
		//		protected extension
		var v = this.inherited(arguments);
		if (isNaN(v) && /\d+/.test(value)) { // currency parse failed, but it could be because they are using NumberTextBox format so try its parse
			v = lang.hitch(lang.delegate(this, { _parser: NumberTextBox.prototype._parser }), "inherited")(arguments);
		}
		return v;
	},

	_setConstraintsAttr: function (/*Object*/ constraints: any) {
		if (!constraints.currency && this.currency) {
			constraints.currency = this.currency;
		}
		this.inherited(arguments, [currency._mixInDefaults(lang.mixin(constraints, { exponent: false }))]); // get places
	}
});

export default CurrencyTextBox;
